import { useEffect, useState } from "react";
import Navbar from "../Layout/Navbar/Navbar";
import Sidebar from "../Layout/Sidebar/Sidebar";
import MapComponent from "../Map/Views/MapComponent";
import FormsRouter from "../Forms/FormsRouter";
import Footer from "../Layout/FootBar/Footer";

export default function Dashboard({ tokenLoaded, token }) {
  useEffect(() => {
    console.log("tokenLoaded:", tokenLoaded);
  }, [tokenLoaded]);

  return (
    <div className="container-xlarge">
      <Navbar />
      <FormsRouter />
      <Sidebar />

      {tokenLoaded && <MapComponent token={token} />}

      <Footer />
    </div>
  );
}
